<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <h4 class="content-subtitle">Default values</h4>
    <div v-if="!isEditing">
      <label for="ref">REF</label>
      <span v-if="this.details.stepID">{{ this.details.stepID }}</span>
      <span v-else>/</span>
    </div>
    <div v-if="isEditing">
      <label for="ref">REF</label>
      <InputDash    
        :isTextArea="false"
        value="Auto"
        :isDisabled="true"
        class="btm-margin"
      />
    </div>

    <div v-if="!isEditing">
      <label for="name">Name</label>
      <span v-if="this.details.name">{{ this.details.name }}</span>
      <span v-else>/</span>
    </div>
    <div v-if="isEditing">
      <label for="name">Name</label>
      <input v-model="name" />
    </div>

    <div v-if="!isEditing">
      <label for="equipment">Equipment</label>
      <span v-if="this.details.equipment">{{ this.details.equipment }}</span>
      <span v-else>/</span>
    </div>
    <div v-if="isEditing">
      <label for="equipment">Equipment</label>
      <input v-model="equipment" />
    </div>
    <div class="shared shared-2">
      <div v-if="!isEditing">
        <label for="instruction">Work Instruction</label>
        <span v-if="this.details.instruction">{{ this.details.instruction }}</span>
        <span v-else>/</span>
      </div>
      <div v-if="isEditing">
        <label for="instruction">Work Instruction</label>
        <input v-model="instruction" />
      </div>

      <div v-if="!isEditing">
        <label for="location">Location</label>
        <span v-if="this.details.location">{{ this.details.location }}</span>
        <span v-else>/</span>
      </div>
      <div v-if="isEditing">
        <label for="location">Location</label>
        <input v-model="location" />
      </div>
    </div>

    <div class="shared shared-2">
      <div v-if="!isEditing">
        <label for="operator">Operator</label>
        <span>Auto</span>
      </div>
      <div v-if="isEditing">
        <label for="operator">Operator</label>
        <InputDash    
          :isTextArea="false"
          value="Auto"
          :isDisabled="true"
          class="btm-margin"
        />
      </div>

      <div v-if="!isEditing">
        <label for="date">Date</label>
        <span>Auto</span>
      </div>
      <div v-if="isEditing">
        <label for="date">Date</label>
        <InputDash    
          :isTextArea="false"
          value="Auto"
          :isDisabled="true"
          class="btm-margin"
        />
      </div>

    </div>

    <div class="shared shared-2">
      <div v-if="!isEditing">
        <label for="deviations">Deviations</label>
        <InputToggle :isChecked="this.details.deviations == 0 ? false : true" :isDisabled="true" />
      </div>
      <div v-if="isEditing">
        <label for="deviations">Deviations</label>
        <InputToggle @toggle="toggleDeviation" :isChecked="this.deviations" :isDisabled="false" />
      </div>
      <div v-if="!isEditing">
        <label for="samplecount">Sample count</label>
        <InputToggle :isChecked="this.details.samplecount == 0 ? false : true" :isDisabled="true" />
      </div>
      <div v-if="isEditing">
        <label for="samplecount">Sample count</label>
        <InputToggle @toggle="toggleSample" :isChecked="this.samplecount" :isDisabled="false" />
      </div>
    </div>

    <div v-if="!isEditing && this.userDetails.isAdmin == 1" class="icon submit" @click="startEditing">
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";
import InputToggle from "@/components/base/InputToggle.vue";

export default {
  components: {
    BaseIcon,
    InputDash,
    InputToggle
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    details: Object
  },
  data() {
    return {
      isEditing: false,
      stepID: Number,
      name: String,
      equipment: String,
      location: String,
      instruction: String,
      deviations: Boolean,
      samplecount: Boolean,
      QRParameter: String,
    };
  },
  watch: {
    details: {
      handler: function() {
        this.isEditing = false;
        this.setSelectedData()
      }
    }
  },
  mounted() {
   this.setSelectedData()
  },
  methods: {
    setSelectedData(){
      this.stepID = this.details.stepID
      this.name = this.details.name
      this.equipment = this.details.equipment
      this.deviations = this.details.deviations == 0 ? false : true
      this.instruction = this.details.instruction
      this.location = this.details.location
      this.samplecount = this.details.samplecount
      this.QRParameter = this.details.QRParameter
    },
    startEditing() {
      this.isEditing = true;
    },
    editStep() {
      let that = this;

      this.$http.put(this.$endpoint + "management/productionStep/step", {
          stepID: this.stepID,
          equipment: this.equipment,
          name: this.name,
          ref: this.ref,
          deviations: this.deviations,
          instruction: this.instruction,
          location: this.location,
          QRParameter: this.QRParameter,
          samplecount: this.samplecount,
        })
        .then(function(response) {
          that.$swal(
            'Production step updated!',
            `Your custom values for this production step has been successfully updated.`,
            'success'
          );
          that.$emit("refresh", true);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
    },
    stopEditing() {
      this.editStep();
      this.isEditing = false;
      this.$emit("refresh", true);
    },
    toggleDeviation() {
      this.deviations = !this.deviations;
    },
    toggleSample() {
      this.samplecount = !this.samplecount;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/pages/content";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 690px;

  label {
    height: 20px;
  }

  input,
  span {
    height: 30px;
    margin-bottom: 15px;
  }
}
</style>